module.exports = __webpack_public_path__ + "static/media/crowd2.c0ad869d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/crowd2.jpg
// module id = 538
// module chunks = 0